Number.prototype.toMoney = function() {
  return this.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
